import { render, staticRenderFns } from "./retouchingFile.vue?vue&type=template&id=510fbc73&scoped=true"
import script from "./retouchingFile.vue?vue&type=script&lang=js"
export * from "./retouchingFile.vue?vue&type=script&lang=js"
import style0 from "./retouchingFile.vue?vue&type=style&index=0&id=510fbc73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510fbc73",
  null
  
)

export default component.exports